import script from "./g9.vue?vue&type=script&setup=true&lang=js"
export * from "./g9.vue?vue&type=script&setup=true&lang=js"

import "./g9.vue?vue&type=style&index=0&id=91660822&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91660822"]])

export default __exports__